import { DataProvider as RADataProvider, withLifecycleCallbacks } from 'react-admin';
import { AuthProvider, httpClient } from './AuthProvider';
import getList from './getList';
import getOne from './getOne';
import getMany from './getMany';
import getManyReference from './getManyReference';
import create from './create';
import update from './update';
import updateMany from './updateMany';
import deleteFn from './delete';
import deleteMany from './deleteMany';
import createMany, { CreateMany } from './createMany';
import batch, { Batch } from './batch';
import LifecycleCallbacks from './LifecycleCallbacks';
import {
  recalculateBudgetStatus,
  RecalculateBudgetStatus,
  syncMerchantWithNetSuite,
  SyncWithNetSuite,
} from './CustomMethods/Merchant';
import mappingRuleCategoryBulkRemap, {
  MappingRuleCategoryBulkRemap,
} from './CustomMethods/mappingRuleCategoryBulkRemap';
import {
  clickMerchantCreate,
  clickReferrerCreate,
  clickSummaryCreate,
  merchantOfferSummaryCreate,
  ReportClickMerchantCreate,
  ReportClickReferrerCreate,
  ReportClickSummaryCreate,
  ReportMerchantOfferSummaryCreate,
} from './CustomMethods/Report';

export * from './JsonApiTypes';
export { AuthProvider, httpClient } from './AuthProvider';
export * from './Hooks';
export type { Batch, BatchOperation } from './batch';
export type {
  RecalculateBudgetStatusResponse,
  SyncWithNetSuiteResponse as SyncMerchantWithNetSuiteResponse,
} from './CustomMethods/Merchant';

export type GPDataProvider = RADataProvider & {
  batch: Batch;
  createMany: CreateMany;
  mappingRuleCategoryBulkRemap: MappingRuleCategoryBulkRemap;
  merchantRecalculateBudgetStatus: RecalculateBudgetStatus;
  merchantSyncWithNetSuite: SyncWithNetSuite;
  reportClickMerchantCreate: ReportClickMerchantCreate;
  reportClickReferrerCreate: ReportClickReferrerCreate;
  reportClickSummaryCreate: ReportClickSummaryCreate;
  reportMerchantOfferSummaryCreate: ReportMerchantOfferSummaryCreate;
};

export const DataProvider = (apiUrl: string, authProvider: typeof AuthProvider): GPDataProvider =>
  withLifecycleCallbacks(
    {
      // React Admin base data provider methods
      create: create(apiUrl, httpClient),
      delete: deleteFn(apiUrl, httpClient),
      deleteMany: deleteMany(apiUrl, httpClient, authProvider.canAccess),
      getList: getList(apiUrl, httpClient, getOne(apiUrl, httpClient)),
      getMany: getMany(apiUrl, httpClient),
      getManyReference: getManyReference(apiUrl, httpClient),
      getOne: getOne(apiUrl, httpClient),
      update: update(apiUrl, httpClient),
      updateMany: updateMany(apiUrl, httpClient, authProvider.canAccess),

      // React Admin options
      supportAbortSignal: true,

      // Custom methods
      batch: batch(apiUrl, httpClient, authProvider.canAccess),
      createMany: createMany(apiUrl, httpClient, authProvider.canAccess),
      mappingRuleCategoryBulkRemap: mappingRuleCategoryBulkRemap(apiUrl, httpClient),
      merchantRecalculateBudgetStatus: recalculateBudgetStatus(apiUrl, httpClient),
      merchantSyncWithNetSuite: syncMerchantWithNetSuite(apiUrl, httpClient),
      reportClickMerchantCreate: clickMerchantCreate(apiUrl, httpClient, authProvider.canAccess),
      reportClickReferrerCreate: clickReferrerCreate(apiUrl, httpClient, authProvider.canAccess),
      reportClickSummaryCreate: clickSummaryCreate(apiUrl, httpClient, authProvider.canAccess),
      reportMerchantOfferSummaryCreate: merchantOfferSummaryCreate(
        apiUrl,
        httpClient,
        authProvider.canAccess,
      ),
    },
    LifecycleCallbacks,
  );
